import { render, staticRenderFns } from "./RecalcBiRecords.vue?vue&type=template&id=8763a160&"
import script from "./RecalcBiRecords.vue?vue&type=script&lang=js&"
export * from "./RecalcBiRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports